import { render } from "./FolderTree.vue?vue&type=template&id=021f5de6&scoped=true"
import script from "./FolderTree.vue?vue&type=script&lang=js"
export * from "./FolderTree.vue?vue&type=script&lang=js"

import "./FolderTree.vue?vue&type=style&index=0&id=021f5de6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021f5de6"]])

export default __exports__